export default "__VITE_PUBLIC_ASSET__620c740f__"